import { Http } from 'services/http';
import { API_CHAT_URL } from 'consts/common.const';

export const getUser = (keyword: string) => {
  return Http.request({
    method: 'GET',
    url: `${API_CHAT_URL}/user/search?keyword=${keyword}`,
  });
};
